import { NgModule } from '@angular/core'
import { CountryBarComponent } from './country-bar.component'
import { CmsComponentsBaseModule } from '../cms-components-base.module'
import { MbI18nModule } from '../../../translations/mb-i18n.module'

@NgModule({
  declarations: [
    CountryBarComponent
  ],
  imports: [
    CmsComponentsBaseModule,
    MbI18nModule
  ],
  exports: [
    CountryBarComponent
  ]
})
export class CountryBarModule {}

export interface CountryBarBtn {
  text: string;
  alt: string;
  title: string;
  eventAction: string;
  eventLabel: string;
  country: string;
  class: string;
  navigate: boolean;
}

export interface CountryBarTranslation {
  key: string;
  country: string;
}
